module.exports = __webpack_public_path__ + "img/arrow-grey.2b234122.svg";